import React, { useState, useEffect } from "react";
import shortid from "shortid";
import Button from "@mui/material/Button";
import { SpinnerCircular } from "spinners-react";

import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

import useHttp from "../../../../hooks/useHttp";
import { CHANGE_PASSWORD_URL } from "../../../../utils/api-ends";
import { useNavigate } from 'react-router-dom';

const Security = () => {
  const { error, isLoading, sendRequests } = useHttp();

  const [allValues, setAllValues] = useState({
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });
  const [allError, setAllError] = useState({
    confirmNewPasswordError: [],
    newPasswordError: [],
    oldPasswordError: [],
    passwordError: [],
    nonFieldError: [],
  });
  const [successMessage, setSuccessMessage] = useState("");

  //Update state values when input values change.
  const handleInputChange = (e) => {
    setAllValues({ ...allValues, [e.target.name]: e.target.value });
  };

  // Clean error messages when click on the input
  const hideErrorMessage = (e) => {
    const attrValue = e.target.getAttribute("name");
    attrValue === "old_password"
      ? setAllError({ ...allError, oldPasswordError: [] })
      : attrValue === "new_password"
      ? setAllError({ ...allError, newPasswordError: [] })
      : attrValue === "confirm_new_password"
      ? setAllError({ ...allError, confirmNewPasswordError: [] })
      : setAllError({ ...allError });
  };

  const handleSubmit = (e) => {
    if (isLoading) {
      return false;
    }

    e.preventDefault();
    const formData = new FormData();

    //set formdata values
    for (var key in allValues) {
      formData.append(key, allValues[key]);
    }

    const response = (data) => {
      // Set success messages
      setSuccessMessage(data.message);
      // Clear success messages
      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);
    };

    // Send request to update password
    sendRequests(
      {
        url: CHANGE_PASSWORD_URL,
        method: "PUT",
        data: formData,
      },
      response
    );

    // Clear error messages after submitting form data
    setAllError({
      oldPasswordError: [],
      newPasswordError: [],
      confirmNewPasswordError: [],
      passwordError: [],
      nonFieldError: [],
    });

    // scroll to top
    window.scrollTo(0, 100);
  };

  useEffect(() => {
    // set error message in state
    if (error) {
      setAllError({
        ...allError,
        ["oldPasswordError"]: error.old_password ? error.old_password : [],
        ["newPasswordError"]: error.new_password ? error.new_password : [],
        ["confirmNewPasswordError"]: error.confirm_new_password
          ? error.confirm_new_password
          : [],
        ["passwordError"]: error.password ? error.password : [],
        ["nonFieldError"]: error.non_field_error ? error.non_field_error : [],
        ["nonFieldError"]: error.general ? error.general : [...allError.nonFieldError],
      });
    }
  }, [error , allError]);


  const navigate = useNavigate();
  const handleCancel = () => {
    navigate(-1); // Go back to the previous page
  }

  return (
    <div className="col-lg-7 mx-auto">
      {successMessage !== "" ? (
        <Alert severity="success">
          <AlertTitle>Success</AlertTitle>
          <strong>{successMessage}</strong>
        </Alert>
      ) : (
        ""
      )}

      <div className="row">
        {allError.nonFieldError?.map((error, index) => (
          <Alert severity="error">
            <strong>{error}</strong>
          </Alert>
        ))}
      </div>

      <div className="input-box-area" single-labe="true">
        <label> Current Password</label>
        <input
          type="password"
          name="old_password"
          onChange={handleInputChange}
          onClick={hideErrorMessage}
        />
        <div className="error" show-tittle="true">
          {allError.oldPasswordError.length > 0 ? (
            <div>
              {" "}
              <i className="fa-solid fa-circle-exclamation"></i>{" "}
            </div>
          ) : (
            ""
          )}
          {allError.oldPasswordError?.map((error, index) => (
            <div key={shortid.generate()}>
              <p className="auth-error" key={index}>
                {error}
              </p>
            </div>
          ))}
        </div>
      </div>

      <p className="input-fill-up-instruction">
        Your password can’t be too similar to your other personal information.{" "}
        <br />
        Your password must contain at least 8 characters. <br />
        Your password can’t be a commonly used password. <br />
        Your password can’t be entirely numeric.
      </p>

      <div className="row">
        {allError.passwordError?.map((error, index) => (
          <Alert severity="error" key={shortid.generate()}>
            <strong>{error}</strong>
          </Alert>
        ))}
      </div>

      <div className="input-box-area" single-labe="true">
        <label> New Password </label>
        <input
          type="password"
          name="new_password"
          onChange={handleInputChange}
          onClick={hideErrorMessage}
        />
        <div className="error" show-tittle="true">
          {allError.newPasswordError.length > 0 ? (
            <div>
              {" "}
              <i className="fa-solid fa-circle-exclamation"></i>{" "}
            </div>
          ) : (
            ""
          )}
          {allError.newPasswordError?.map((error, index) => (
            <div key={shortid.generate()}>
              <p className="auth-error" key={index}>
                {error}
              </p>
            </div>
          ))}
        </div>
      </div>

      <div className="input-box-area" single-labe="true">
        <label> Confirm New Password </label>
        <input
          type="password"
          name="confirm_new_password"
          onChange={handleInputChange}
          onClick={hideErrorMessage}
        />
        <div className="error" show-tittle="true">
          {allError.confirmNewPasswordError.length > 0 ? (
            <div>
              {" "}
              <i className="fa-solid fa-circle-exclamation"></i>{" "}
            </div>
          ) : (
            ""
          )}
          {allError.confirmNewPasswordError?.map((error, index) => (
            <div key={shortid.generate()}>
              <p className="auth-error" key={index}>
                {error}
              </p>
            </div>
          ))}
        </div>
      </div>

      <div className="multiple-btn d-flex flex-row justify-content-center mt-5 flex-wrap">
      
        <Button className="mx-1" onClick={handleSubmit}>
          Update Password
          {isLoading && (
            <SpinnerCircular
              size={22}
              thickness={180}
              speed={130}
              color="#fff"
              className="btn-loader"
              secondaryColor="rgba(57, 172, 127, 0.44)"
            />
          )}
        </Button>

        <Button className="mx-1" onClick={handleCancel}>
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default Security;
